<template>
  <div>
    <div class="columns">
      <div class="column is-narrow" style="padding-right: 0;">
        <b-field>
          <b-input icon="magnify" v-model="search" placeholder="Cari..." style="font-size: inherit;"></b-input>
        </b-field>
      </div>

      <div class="column is-narrow">
        <div class="columns is-mobile">
          <div class="column is-narrow" style="padding-right: 0;">
            <div class="field cari-post">
              <div class="control">
                <div class="select">
                  <select v-model="sort">
                    <option value="">Pilih Urutan</option>
                    <option v-for="(s, key) in sort_options" :key="key" :value="s.value">{{ s.text }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <a class="button is-primary tooltip is-tooltip-right" data-tooltip="Terapkan" @click.prevent="clickHandler((folderId != null) ? folderId : '', false)" :disabled="loading" :class="{'is-loading': loading}">
              <span class="icon"><i class="fas fa-filter"></i></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filterDrive: {
      type: Object,
      required: true
    },
    folderId: {
      type: String,
      default: "",
      required: false
    },
    clickHandler: {
      type: Function,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    search: {
      get() {
        const search = this.filterDrive.searchDrive;

        return !this.isEmpty(search) ? search : '';
      },
      set(val) {
        const vm = this;

        if (!this.isEmpty(val)) {
          vm.filterDrive.searchDrive = `${val}`;
        } else {
          vm.filterDrive.searchDrive = '';
        }
      }
    },
    sort: {
      get() {
        const vm = this
        const sort = this.filterDrive.sortDrive;
        let option = null;

        if (!vm.isEmpty(sort)) {
          option = collect(this.sort_options).where('value', '==', sort).first();
        }

        return !this.isEmpty(option) ? option.value : '';
      },
      set(val) {
        const vm = this;

        let option = collect(vm.sort_options).where('value', '==', val).first();

        if (!this.isEmpty(option)) {
          this.filterDrive.sortDrive = option.value
        }

      }
    },
  },

  data() {
    return {
      open: false,
      sort_options: [
        { criteria: 'name', order: 'asc', value: 'name asc', text: 'A - Z' },
        { criteria: 'name', order: 'desc', value: 'name desc', text: 'Z - A' },
        { criteria: 'created_at', order: 'desc', value: 'modifiedTime desc', text: 'Terbaru' },
        { criteria: 'created_at', order: 'asc', value: 'modifiedTime asc', text: 'Terlama' },
        { criteria: 'size', order: 'desc', value: 'quotaBytesUsed desc', text: 'Ukuran Terbesar' },
        { criteria: 'size', order: 'asc', value: 'quotaBytesUsed asc', text: 'Ukuran Terkecil' },
      ]
    }
  }
}
</script>
